import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseSpreadMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/components/fp-logger-noise-spread-minimized/fp-logger-noise-spread-minimized.component';
import { FpLoggerNoiseSpreadComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/components/fp-logger-noise-spread/fp-logger-noise-spread.component';
import { FpLoggerNoiseSpreadActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread/fp-logger-noise-spread.actions';
import { FpLoggerNoiseSpreadStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread/fp-logger-noise-spread.store';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseSpreadConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseSpreadStore);
  public currentTab = FpLoggerNoiseTabs.Spread;

  public component: Type<unknown> = FpLoggerNoiseSpreadComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseSpreadMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSpreadActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseSpreadActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
